import React from 'react';
import { CardMedia, Grid } from '@mui/material';

import { Block, Header } from '../CommonComponents';
import { Container } from '../StyledComponents';

import { videoUrls } from '../CommonComponents/VideoHelpModal';

function VideoCard({ title, videoUrl }: { title: string; videoUrl: string }) {
    return (
        <CardMedia
            component="iframe"
            src={videoUrl}
            title={title}
            allowFullScreen
            sx={{
                width: '100%',
                height: 300,
                border: 'none',
                borderRadius: 2,
                padding: 3
            }}
        />
    );
}

export default function Help() {
    return (
        <Container>
            <Header title="Hjälp" />
            <Grid container spacing={2} sx={{ mt: -1 }}>
                {videoUrls.map((video) => (
                    <Grid item sm={12} md={6} lg={6} xl={4} key={video.title}>
                        <Block
                            title={video.title}
                        >
                            <VideoCard
                                videoUrl={video.url}
                                title={video.title}
                            />
                        </Block>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}
